<template>
  <b-modal
      ref="add-coins-modal"
      size="lg"
      :title="$t(title.toString())"
  >
    <b-form>
      <b-form-group
          :label="$t('locale.form.name')" label-for="input-2">
        <b-form-input
            id="input-2"
            v-model="form.name"
            :state="!$v.form.name.$dirty ? null :(!$v.form.name.$error)"
            required
        ></b-form-input>
      </b-form-group>

      <b-form-group
          :label="$t('locale.form.label')" label-for="input-1">
        <b-form-input
            id="input-1"
            v-model="form.label"
            :state="!$v.form.label.$dirty ? null :(!$v.form.label.$error)"
            required
        ></b-form-input>
      </b-form-group>

      <b-form-group
          :label="$t('locale.form.status')"
          label-for="status"
      >
        <b-form-select
            id="status"
            v-model="form.status"
            :options="status"
            @change="$v.form.status.$model = $event"
            :state="!$v.form.status.$dirty ? null :(!$v.form.status.$error)"
            value-field="value"
            text-field="text"
        ></b-form-select>
      </b-form-group>

      <b-form-group
          :label="$t('locale.form.group')"
          label-for="group"
      >
        <b-form-select
            id="group"
            v-model="form.domainGroupId"
            :options="domainGroups"
            @change="$v.form.domainGroupId.$model = $event"
            :state="!$v.form.domainGroupId.$dirty ? null :(!$v.form.domainGroupId.$error)"
            value-field="id"
            text-field="name"
        ></b-form-select>
      </b-form-group>

    </b-form>
    <template #modal-footer>
      <div class="w-100">
        <div class="buttons float-right">
          <b-button type="button" variant="secondary" class="mr-1" @click="hideModal()">{{$t('btn.cancel')}}</b-button>
          <b-button variant="primary" :disabled="busy" @click="submit()">
            <div v-if="busy">
              <b-spinner small type="grow"></b-spinner>
              {{ $t('btn.state.saving') }}
            </div>
            <div v-else>
              {{ $t('btn.save') }}
            </div>
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {required} from "vuelidate/lib/validators";

export default {
  data() {
    return {
      title: null,
      busy: false,
      groups: [],
      serverError: null,
      status: [
        {value: 'PUBLISHED', text: this.$t('option.published')},
        {value: 'DRAFT', text: this.$t('option.draft')},
      ],
      form: {
        status: null,
        name: null,
        label: null,
        domainGroupId: null,
        comment: null,
      },
    }
  },
  validations: {
    form: {
      domainGroupId: {
        required
      },
      status: {
        required
      },
      label: {
        required
      },
      name: {
        required
      }
    }
  },
  mounted() {
    this.openModal();
  },
  computed: {
    domainGroups: function () {
      return this.$store.getters['translations/domainGroups'];
    }
  },
  methods: {
    submit() {

    },
    openModal() {
      this.$refs['add-coins-modal'].show();
    },
    hideModal() {
      this.$refs['add-coins-modal'].hide();
    },
    isRestricted: function(e) {
      e = (e) ? e : window.event;
      let charCode = (e.which) ? e.which : e.keyCode;
      // 0-9 and . are allowed
      if (charCode !== 44 && charCode !== 46 && (charCode < 48 || charCode > 57)) {
        e.preventDefault();
      } else {
        return true;
      }
    }
  }
}
</script>
